/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
import * as queryString from 'querystring';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Link from 'next/link';
import { Elements, useStripe } from '@stripe/react-stripe-js';
import { Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Router from 'next/router';
import { loadStripe } from '@stripe/stripe-js';
import Head from 'next/head';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import Cookies from 'lib/js-cookie';
import cookies from 'lib/next-cookies';
import { getAudioSeriesEpisodeUrl, getPodcastEpisodeUrl, languages } from 'apis/podcast';
import { gtmEvents } from 'utils/gtm.ts';
import MyEpisode from 'components/MyEpisode';
import SharePopup from 'components/Toast/SharePopup';
import { toast } from 'react-toastify';
import styles from '../../p/[podcast-name]/SinglePublicPodcast.module.scss';
import css from './SingleEpisode.module.scss';
import PublicTopNavigation from '../../../components/Navigation/PublicTopNavigation';
import routes from '../../../utils/routes';
import {
  getCurrency,
  getSubdomain,
  translate as t,
} from '../../../utils/helpers';
import PodcastSubscription from '../../../components/SubscriberForms/PodcastSubscription';
import { openEpisodeDetail, otherEpisodes } from '../../../apis/episode';
import UserContext from '../../../context/UserContext';
import { getProfileData } from '../../../apis/profile';
import { cancelSubscription } from '../../../apis/subscription';
import useLang from '../../../context/LanguageContext';
import ConfirmationPopup from '../../../components/Toast/ConfirmationPopup';
import MessagePopup from '../../../components/Toast/MessagePopup';
import PublicFooter from '../../../components/Footer/PublicFooter';
import { getStripePurchaseHandler } from '../../../utils/stripe';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_ID);

function withElementsProvider(Component) {
  function newComponent(props) {
    return (
      <Elements stripe={stripePromise}>
        <Component {...props}></Component>
      </Elements>
    );
  }

  return newComponent;
}

// eslint-disable-next-line import/no-mutable-exports
let EpisodePage = ({
  episodeData,
  podcastData,
  slug,
  host,
  subscriptionConfirmation,
  token,
  podcaster,
  isPodcast,
  latestBlogPost,
  otherEpisode,
}) => {
  const [userData, setUserData] = useContext(UserContext);
  const stripe = useStripe();

  const [showPlanSelectModal, setShowPlanSelectModal] = useState(false);
  const [, setPodcastLanguages] = useState([]);
  const planTypeRef = useRef('monthly');
  const { lang } = useLang();
  // const siteLang =
  //     (podcastLanguages.find((language) => podcastLanguage === language?.id)
  //         ?.name || 'English') === 'Spanish'
  //         ? 'es'
  //         : 'en';
  const siteLang = podcastData?.creator_language;

  const currency = getCurrency(podcastData?.currency);
  const [profileData, setProfileData] = useState({});
  const [subBtnLoading, setSubBtnLoading] = useState(false);
  const [showMore, setShowMore] = useState(true);

  // const [otherEpisodeList, setOtherEpisodeList] = useState();
  // const [episodeLoading, setEpisodeLoading] = useState(false);
  // const [latestBlogPostList, setLatestBlogPostList] = useState(null);

  const [showConfirmationBox, setShowConfirmationBox] = useState(
    subscriptionConfirmation === slug,
  );
  const [modalShow, setModalShow] = useState(false);

  const [message, setMessage] = useState(
    isPodcast
      ? {
          type: subscriptionConfirmation === slug ? 'subscribe' : '',
          title:
            subscriptionConfirmation === slug
              ? t(siteLang, 'podcast')('subscribeTitle')
              : '',
          message:
            subscriptionConfirmation === slug
              ? userData.isCardExpired
                ? t(siteLang, 'podcast')('cardExpiredMessage')
                : t(siteLang, 'podcast')('subscribeDescription')
              : '',
          cardExpiresMessage: userData.isCardExpired,
        }
      : {
          type: subscriptionConfirmation === slug ? 'purchase' : '',
          title:
            subscriptionConfirmation === slug
              ? t(siteLang, 'podcast')('subscribeTitle')
              : '',
          message:
            subscriptionConfirmation === slug
              ? userData.isCardExpired
                ? t(siteLang, 'podcast')('cardExpiredMessageAudioSeries')
                : t(siteLang, 'podcast')('subscribeDescription')
              : '',
          cardExpiresMessage: userData.isCardExpired,
        },
  );

  const [showSubscriptionMessage, setShowSubscriptionMessage] = useState(false);

  const showListenNowSection =
    podcastData?.apple_podcast ||
    podcastData?.spotify ||
    podcastData?.overcast ||
    podcastData?.ivoox ||
    podcastData?.youtube;

  const showSubscribeButtons = !podcastData?.hide_subscribe_buttons;
  const [redirectUrl, setRedirectUrl] = useState(null);
  useEffect(() => {
    if (window !== undefined) {
      const temp = window?.location?.href;
      setRedirectUrl(temp);
    }
  }, []);

  // const podcaster = parseInt(podcaster1, 10);

  function chooseSubscriptionPlan() {
    setShowPlanSelectModal(true);
  }

  useEffect(async () => {
    if (
      userData?.reqForBtn?.includes('prev') ||
      userData?.reqForBtn?.includes('next')
    ) {
      let playList = [episodeData];
      // const podcaster = Cookies.get('podcaster');
      if (
        !podcastData?.user_subscribed &&
        podcastData?.creator !== podcaster &&
        !(podcastData?.free_podcast || parseFloat(podcastData?.price) === 0)
      ) {
        playList = episodeData?.type !== 1 ? [episodeData] : [];
      }
      const currentIndex = playList
        .map((item) => item.id)
        .indexOf(userData?.episodeDetail?.id);
      let episodeObj = playList[currentIndex - 1];
      if (userData?.reqForBtn?.includes('next'))
        episodeObj = playList[currentIndex + 1];
      if (episodeObj?.id) {
        const response =
          episodeObj.audio_type === 'podcast'
            ? await getPodcastEpisodeUrl(episodeObj?.id)
            : await getAudioSeriesEpisodeUrl(episodeObj.id);

        if (response.status === 200) {
          let episodeDetail = {};
          if (podcastData?.audio_type === 'podcast') {
            episodeDetail = {
              url:
                episodeObj?.type === 1 &&
                !episodeObj?.podcast_details?.user_subscribed &&
                episodeObj?.podcast_details?.creator !== podcaster
                  ? response?.data?.promo_presined_url
                  : response?.data?.presigned_url_get_object,
              episode_name: episodeObj?.name,
              hosted_by: episodeObj?.podcast_details?.creator_name,
              cover: episodeObj?.cover_webp,
              podcast_name: episodeObj?.podcast_details?.title,
              podcast_slug: slug,
              description: episodeObj?.description,
              id: episodeObj?.id,
              audio_type: episodeObj?.audio_type,
              episode_redirect_url: episodeObj?.domain_redirect_url,
              creator_domain_url: episodeObj?.creator_page_url,
            };
          } else {
            episodeDetail = {
              url:
                episodeObj?.type === 1 &&
                !episodeObj?.podcast_details?.user_subscribed &&
                episodeObj?.podcast_details?.creator !== podcaster
                  ? response?.data?.promo_presined_url
                  : response?.data?.presigned_url_get_object,
              episode_name: episodeObj?.name,
              hosted_by: episodeObj?.audio_series_details?.creator_name,
              cover: episodeObj?.cover_webp,
              podcast_name: episodeObj?.audio_series_details?.title,
              podcast_slug: slug,
              description: episodeObj?.description,
              id: episodeObj?.id,
              audio_type: episodeObj?.audio_type,
              episode_redirect_url: episodeObj?.domain_redirect_url,
              creator_domain_url: episodeObj?.creator_page_url,
            };
          }
          setUserData((prevState) => ({
            ...prevState,
            showPlayer: true,
            audioStatus: true,
            episodeDetail,
          }));
        }
      } else {
        // if (!userData?.audioStatus && userData?.hasEnded) {
        closePlayer();
        // }
      }
    }
  }, [userData.reqForBtn]);

  useEffect(() => {
    const tkn = Cookies.get('token');
    const getData = async () => {
      const response = await getProfileData();
      if (response?.status === 200) {
        setProfileData(response?.data);
      } else {
        setProfileData({});
      }
    };
    if (tkn) {
      getData();
    }

    const getLanguages = async () => {
      const response = await languages();
      if (response?.status === 200) {
        setPodcastLanguages(response?.data);
      }
    };
    getLanguages();
  }, []);

  // useEffect(() => {
  //   if (otherEpisode) {
  //     setOtherEpisodeList(otherEpisode);
  //   }
  // }, [otherEpisode]);

  // useEffect(() => {
  //   if (latestBlogPost) {
  //     setLatestBlogPostList(
  //       latestBlogPost?.map((item) => {
  //         const tempElement = document.createElement('div');
  //         tempElement.innerHTML = item?.content?.rendered;

  //         // Extract the text content from the temporary element
  //         const textContent = tempElement.textContent || tempElement.innerText;

  //         return { ...item, contentToString: textContent };
  //       }),
  //     );
  //   }
  // }, [latestBlogPost]);

  // const getOtherEpisodeList = async () => {
  //   setEpisodeLoading(true);
  //   const response = await otherEpisodes(episodeId);
  //   if (response?.status === 200) {
  //     setOtherEpisodeList(response?.data?.data);
  //   }
  //   setEpisodeLoading(false);
  // };

  // const getLatestBlogList = async () => {
  //   const params = queryString.stringify({ per_page: 6 });
  //   const url = `https://mumbler.io/${siteLang}/wp-json/wp/v2/posts/?${params}`;
  //   const response = await axios.get(url);
  //   if (response?.status === 200) {
  //     setLatestBlogPostList(
  //       response.data.map((item) => {
  //         const tempElement = document.createElement('div');
  //         tempElement.innerHTML = item?.content?.rendered;

  //         // Extract the text content from the temporary element
  //         const textContent = tempElement.textContent || tempElement.innerText;

  //         return { ...item, contentToString: textContent };
  //       }),
  //     );
  //   }
  // };

  const playEpisode = async (item) => {
    if (
      item?.type === 1 &&
      !podcastData?.user_subscribed &&
      podcastData?.creator !== podcaster &&
      !item?.promo_presined_url &&
      !(podcastData?.free_podcast || parseFloat(podcastData?.price) === 0)
    ) {
      if (podcastData?.audio_type === 'podcast') {
        setMessage({
          type: 'subscribe',
          title: t(lang, 'podcast')('subcribe'),
          message: t(lang, 'podcast')('onlyForSubscribersSubscribeNow'),
        });
      } else {
        setMessage({
          type: 'purchase',
          title: t(lang, 'podcast')('purchaseAudio'),
          message: t(lang, 'podcast')('onlyForCustomerPurchaseNow'),
        });
      }
      if (!showSubscribeButtons) setShowSubscriptionMessage(true);
      else setShowConfirmationBox(true);
      return false;
    }
    if (userData?.episodeDetail?.id === item?.id) {
      setUserData((prevState) => ({
        ...prevState,
        showPlayer: true,
        audioPlayStatus: !userData?.audioPlayStatus,
      }));
      return false;
    }
    document?.body?.classList?.add('audio-player-active');

    const response =
      item.audio_type === 'podcast'
        ? await getPodcastEpisodeUrl(item?.id)
        : await getAudioSeriesEpisodeUrl(item.id);

    if (response.status === 200) {
      let episodeDetail = {};
      if (podcastData?.audio_type === 'podcast') {
        episodeDetail = {
          url:
            item?.type === 1 &&
            !item?.podcast_details?.user_subscribed &&
            item?.podcast_details?.creator !== podcaster &&
            !(podcastData?.free_podcast || parseFloat(podcastData?.price) === 0)
              ? response?.data?.promo_presined_url
              : response?.data?.presigned_url_get_object,
          episode_name: item?.name,
          hosted_by: item?.podcast_details?.creator_name,
          cover: item?.cover_webp,
          podcast_name: item?.podcast_details?.title,
          podcast_slug: slug,
          description: item?.description,
          id: item?.id,
          audio_type: item?.audio_type,
          episode_redirect_url: item?.domain_redirect_url,
          creator_domain_url: item?.creator_page_url,
        };
      } else {
        episodeDetail = {
          url:
            item?.type === 1 &&
            !item?.audio_series_details?.user_subscribed &&
            item?.audio_series_details?.creator !== podcaster &&
            !(parseFloat(item?.audio_series_details?.price) === 0)
              ? response?.data?.promo_presined_url
              : response?.data?.presigned_url_get_object,
          episode_name: item?.name,
          hosted_by: item?.audio_series_details?.creator_name,
          cover: item?.cover_webp,
          podcast_name: item?.audio_series_details?.title,
          podcast_slug: slug,
          description: item?.description,
          id: item?.id,
          audio_type: item?.audio_type,
          episode_redirect_url: item?.domain_redirect_url,
          creator_domain_url: item?.creator_page_url,
        };
      }

      setUserData((prevState) => ({
        ...prevState,
        showPlayer: true,
        audioPlayStatus: true,
        isOnRefresh: false,
        episodeDetail,
      }));
    }
  };
  const closePlayer = () => {
    document?.body?.classList?.remove('audio-player-active');
    if (process.env.NEXT_PUBLIC_FRONTEND_URL === 'http://localhost:3000') {
      Cookies.remove('playerData', { path: '/' });
    } else {
      Cookies.remove('playerData', { path: '/', domain: '.mumbler.io' });
    }
    setUserData((prevState) => ({
      ...prevState,
      showPlayer: false,
      audioPlayStatus: false,
    }));
  };

  // const openSharingBox = async () => {
  //   const isMobBrowser = detectMobileBrowser();
  //   if (isMobBrowser && navigator?.share) {
  //     const shareData = {
  //       url: `${podcastData?.domain_redirect_url}`,
  //       text: t(siteLang, 'podcast')('podcastShareMessage', {
  //         link: podcastData?.title,
  //       }),
  //       description: podcastData?.description,
  //     };
  //     try {
  //       await navigator.share(shareData);
  //     } catch (e) {
  //       if (e.toString().includes('AbortError')) {
  //         console.log('Share aborted :(');
  //       }
  //     }
  //   } else {
  //     setModalShow(true);
  //   }
  // };

  function purchaseSuccess() {
    setSubBtnLoading(false);
    gtmEvents.subscriptionStatus({
      status: 'finished',
      podcast: podcastData,
    });
    if (process.env.NEXT_PUBLIC_FRONTEND_URL === 'http://localhost:3000') {
      Cookies.set('new_sub', slug, { expires: 10, path: '/' });
    } else {
      Cookies.set('new_sub', slug, {
        expires: 10,
        path: '/',
        domain: '.mumbler.io',
      });
    }
    Router.push(podcastData?.domain_redirect_url);
  }

  // eslint-disable-next-line no-unused-vars
  function purchaseError(error) {
    if (error?.coupon_invalid) {
      toast.error(t(lang, 'podcast')('theProvidedCouponIsInvalidOrUsedUp'));
    } else if (error?.errors?.non_fields_errors) {
      toast.error(t(lang, 'podcast')('userAlreadySubscribedToThisPodcast'));
    } else {
      toast.error(error?.message);
    }
    setSubBtnLoading(false);
  }

  function addPrePurchaseChecks(funct) {
    // eslint-disable-next-line consistent-return
    function inner(...args) {
      setShowConfirmationBox(false);
      const tkn = Cookies.get('token');
      if (podcastData?.creator === podcaster) return false;
      setSubBtnLoading(true);
      gtmEvents.subscriptionStatus({
        status: 'paying',
        podcast: podcastData,
      });
      if (tkn) {
        if (profileData?.stripe_payment_method_id?.length) {
          funct(...args);
        } else Router.push(`${routes.registerPayment()}?podcast=${slug}`);
      }
      // else {
      // 	sessionStorage.setItem('has_subscribed_to', JSON.stringify(podcastData))
      // 	router.push(`${routes.register(lang)}?podcast=${slug}`)
      // 	setSubBtnLoading(false)
      // }
    }

    return inner;
  }

  const subscribeToPodcast = addPrePurchaseChecks(
    getStripePurchaseHandler(stripe, purchaseSuccess, purchaseError),
  );

  // const subscribeToPodcast = (stripe) => {
  //     setShowConfirmationBox(false);
  //     const podcaster = Cookies.get('podcaster');
  //     const tkn = Cookies.get('token');
  //     if (podcastData.creator === podcaster) return false;
  //     setSubBtnLoading(true);
  //     gtmEvents.subscriptionStatus({
  //         status: 'paying',
  //         podcast: podcastData,
  //     });
  //     if (tkn) {
  //         checkUserHasAlreadyAddedCard(stripe);
  //     }
  //     // else {
  //     // 	sessionStorage.setItem('has_subscribed_to', JSON.stringify(podcastData))
  //     // 	router.push(`${routes.register(lang)}?podcast=${slug}`)
  //     // 	setSubBtnLoading(false)
  //     // }
  // };

  const subscribeConfirmation = () => {
    if (token) {
      if (!profileData?.stripe_payment_method_id?.length) {
        Router.push(`${routes.registerPayment()}?podcast=${slug}`);
      } else {
        if (isPodcast) {
          setMessage({
            type: 'subscribe',
            title: t(siteLang, 'podcast')('subscribeTitle'),
            message: userData?.isCardExpired
              ? t(siteLang, 'podcast')('cardExpiredMessage')
              : t(siteLang, 'podcast')('subscribeDescription'),
            cardExpiresMessage: userData?.isCardExpired,
          });
        } else {
          setMessage({
            type: 'purchase',
            title: t(siteLang, 'podcast')('subscribeTitle'),
            message: userData?.isCardExpired
              ? t(siteLang, 'podcast')('cardExpiredMessageAudioSeries')
              : t(siteLang, 'podcast')('purchaseDescription'),
            cardExpiresMessage: userData?.isCardExpired,
          });
        }
        setShowConfirmationBox(true);
      }
    } else {
      if (process.env.NEXT_PUBLIC_FRONTEND_URL === 'http://localhost:3000') {
        Cookies.set(
          'has_subscribed_to',
          JSON.stringify({
            slug: podcastData.slug,
            domain_redirect_url: podcastData.domain_redirect_url,
          }),
          { path: '/' },
        );
      } else {
        Cookies.set(
          'has_subscribed_to',
          JSON.stringify({
            slug: podcastData.slug,
            domain_redirect_url: podcastData.domain_redirect_url,
          }),
          {
            path: '/',
            domain: '.mumbler.io',
          },
        );
      }
      Router.push(`${routes.register(lang)}?podcast=${slug}`);
      setSubBtnLoading(false);
    }
    gtmEvents.subscriptionStatus({
      status: 'started',
      podcastData,
    });
  };

  const unSubscribe = async () => {
    const payload = {
      podcast: podcastData?.id,
    };
    const response = await cancelSubscription(payload);
    if (response?.status === 200) {
      setShowConfirmationBox(false);
      setUserData((prevState) => ({
        ...prevState,
        showModal: true,
        title: t(lang, 'common')('unsubscribedTitle'),
        message: t(lang, 'common')('unsubscribedmessage'),
      }));
      Router.push(routes.accountPodcasts());
    }
  };

  const updateCreditCard = () => {
    Router.push('/account/billing/payment-methods');
  };
  return (
    <div className="page nosidebar">
      <Head>
        <title>
          {episodeData?.name} - {podcastData?.title}
        </title>
        <meta
          property="og:title"
          content={`${episodeData?.name} - ${podcastData?.title}`}
        />
        <meta
          property="og:description"
          content={
            episodeData?.description &&
            episodeData?.description.replace(/(<([^>]+)>)/gi, '')
          }
        />
        <meta property="og:site_name" content={episodeData?.name} />
        <meta property="og:url" content={episodeData?.domain_redirect_url} />
        <meta property="og:image" content={episodeData?.cover} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content={
            episodeData?.description &&
            episodeData?.description.replace(/(<([^>]+)>)/gi, '')
          }
        />
        <meta
          name="twitter:title"
          content={`${episodeData?.name} - ${podcastData?.title}`}
        />
        <meta name="twitter:site" content="@username" />
        <meta name="twitter:image" content={episodeData?.cover} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'PodcastEpisode',
              url: `${episodeData?.domain_redirect_url}`,
              name: `${episodeData?.name} - ${podcastData?.title}`,
              image: `${episodeData?.cover}`,
              datePublished: `${episodeData?.published_at}`,
              timeRequired: `${episodeData?.duration}`,
              description: `${
                episodeData?.description &&
                episodeData?.description.replace(/(<([^>]+)>)/gi, '')
              }`,
              partOfSeries: {
                '@type': 'PodcastSeries',
                name: `${podcastData?.title}`,
                url: `${podcastData?.domain_redirect_url}`,
              },
            }),
          }}
        />
        ;
      </Head>
      <main className="main">
        <Container className="full mobile-full" fluid>
          <Row className={styles.mainRow}>
            <Col lg={12} className={styles.primary}>
              <PublicTopNavigation
                showLine
                lang={lang}
                showAddToPodcatcher={false}
                redirectUrl={redirectUrl}
                // showWordpressLink
              />
              <Container className="wider">
                <div className={`mb-0 ${styles.topSection}`}>
                  <div className={`${styles.imageWrap}`}>
                    {!podcastData?.stop_charging_user ||
                    (podcastData?.stop_charging_user &&
                      (episodeData?.access_content ||
                        (!episodeData?.access_content &&
                          episodeData?.promo_presined_url))) ? (
                      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                      <div
                        className={css.singleEpisodeImageWrap}
                        onClick={() => playEpisode(episodeData)}
                        id={`episode${episodeData?.id}PlayButton`}>
                        <img src={episodeData?.cover_webp} alt="Avatar" />
                        <div className={css.overlay}>
                          {userData?.episodeDetail?.id === episodeData?.id &&
                          userData?.audioPlayStatus ? (
                            <div
                              id={`episode${episodeData?.id}PauseIcon`}
                              className={`pause-icon ${css.pauseIcon}`}
                            />
                          ) : (
                            <div
                              id={`episode${episodeData?.id}PlayIcon`}
                              className={`play-icon ${css.playIcon}`}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className={css.singleEpisodeImageWrap}>
                        <img src={episodeData?.cover_webp} alt="Avatar" />
                      </div>
                    )}
                  </div>
                  <div className={styles.podcastDetailsWrap}>
                    <div className={styles.SinglePodcast}>
                      <div className={styles.titleEditWrap}>
                        <h1 className={styles.mainTitle}>
                          {episodeData?.name}
                        </h1>
                      </div>
                      <Link href={podcastData?.domain_redirect_url || '#'}>
                        <a>
                          {' '}
                          <p className={styles.podcastDescription}>
                            {' '}
                            {podcastData?.title}{' '}
                          </p>{' '}
                        </a>
                      </Link>
                      <div className={styles.podcasterDetails}>
                        <div className={styles.imageWrap}>
                          <img
                            className="img-fluid"
                            src={
                              podcastData?.creator_img ||
                              '/other-icons/user-icon.svg'
                            }
                            alt=""
                          />
                        </div>
                        <div className={styles.podcastContentWrap}>
                          <p className={styles.podcasterDetailsText}>
                            {' '}
                            {t(siteLang, 'podcast')('hostedBy')}{' '}
                          </p>
                          {podcastData?.is_creator_published ? (
                            <Link
                              href={`${podcastData?.creator_page_url}` || '#'}>
                              <a
                                className={`${styles.mainTitleLink} no-effect`}>
                                <h2 className={styles.podcasterName}>
                                  {podcastData?.creator_name}
                                </h2>
                              </a>
                            </Link>
                          ) : (
                            <h2 className={styles.podcasterName}>
                              {podcastData?.creator_name}
                            </h2>
                          )}
                        </div>
                      </div>
                      {episodeData?.type === 1 &&
                      !podcastData?.user_subscribed &&
                      podcastData?.creator !== podcaster ? (
                        showSubscribeButtons ? (
                          <Elements stripe={stripePromise}>
                            <PodcastSubscription
                              lang={siteLang}
                              styles={styles}
                              subscribeToPodcast={
                                podcastData?.audio_type === 'podcast' &&
                                podcastData?.annual_price_enabled
                                  ? chooseSubscriptionPlan
                                  : subscribeConfirmation
                              }
                              podcastData={podcastData}
                              subBtnLoading={subBtnLoading}
                              currency={currency}
                              isEpisode
                              isPodcast={podcastData?.audio_type === 'podcast'}
                            />
                          </Elements>
                        ) : (
                          ''
                        )
                      ) : !podcastData?.stop_charging_user ||
                        (podcastData?.stop_charging_user &&
                          (episodeData?.access_content ||
                            (!episodeData?.access_content &&
                              episodeData.promo_presined_url))) ? (
                        <Button
                          variant="primary"
                          className="compact"
                          onClick={() => playEpisode(episodeData)}>
                          {t(siteLang, 'podcast')('play')}
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
                <Row className={styles.topSectionRow}>
                  {episodeData?.description && (
                    <Col md={12}>
                      <div
                        className={`mt-md-3 mt-4 ${css.episodeDescription}`}
                        dangerouslySetInnerHTML={{
                          __html: episodeData?.description,
                        }}
                      />
                    </Col>
                  )}

                  {(podcastData?.user_subscribed ||
                      podcastData?.creator === podcaster) &&
                    episodeData?.private_note && (
                      <Col md={12}>
                        <div
                          className={`mt-md-3 mt-4 ${css.episodeDescription}`}
                          dangerouslySetInnerHTML={{
                            __html: episodeData?.private_note,
                          }}
                        />
                      </Col>
                    )}

                  {(episodeData?.show_transcription ||
                      podcastData?.user_subscribed ||
                      podcastData?.creator === podcaster) &&
                    episodeData?.transcription && (
                      <Col md={12}>
                        <div className="mt-md-3 mt-4">
                          <h2 className={styles.title}>
                            {t(siteLang, 'podcast')('transcription')}
                          </h2>
                          <div
                            className={`${css.episodeDescription}`}
                            style={{
                              whiteSpace: 'pre-line',
                              color: '#4F4F4F',
                              display: !showMore ? 'block' : '-webkit-box',
                              '-webkit-line-clamp': '10',
                              '-webkit-box-orient': 'vertical',
                              overflow: 'hidden',
                            }}>
                            {episodeData?.transcription}
                          </div>
                          <div
                            onClick={() =>
                              setShowMore((prevState) => !prevState)
                            }
                            style={{ cursor: 'pointer', color: '#0056b3' }}>
                            {showMore
                              ? t(siteLang, 'podcast')('readMore')
                              : t(siteLang, 'podcast')('readLess')}
                          </div>
                        </div>
                      </Col>
                    )}
                </Row>
                {showListenNowSection && (
                  <div
                    className={`${styles.socialIconsWrap} ${styles.listenNowWrap}`}>
                    <h2 className={styles.title}>
                      {t(siteLang, 'podcast')('listenNowOn')}
                    </h2>
                    <div className="mt-4">
                      {podcastData?.apple_podcast && (
                        <a
                          className={`${styles.singleIconWrap} no-effect`}
                          href={podcastData?.apple_podcast || '#'}
                          rel="noreferrer"
                          target="_blank"
                          style={{
                            'pointer-events': podcastData?.apple_podcast
                              ? 'auto'
                              : 'none',
                          }}>
                          <img
                            src="/player-icons/apple-podcasts.svg"
                            className={styles.singleIcon}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                      )}
                      {podcastData?.spotify && (
                        <a
                          className={`${styles.singleIconWrap} no-effect`}
                          href={podcastData?.spotify || '#'}
                          rel="noreferrer"
                          target="_blank"
                          style={{
                            'pointer-events': podcastData?.spotify
                              ? 'auto'
                              : 'none',
                          }}>
                          <img
                            src="/player-icons/spotify.svg"
                            className={styles.singleIcon}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                      )}
                      {podcastData?.overcast && (
                        <a
                          className={`${styles.singleIconWrap} no-effect`}
                          href={podcastData?.overcast || '#'}
                          rel="noreferrer"
                          target="_blank"
                          style={{
                            'pointer-events': podcastData?.overcast
                              ? 'auto'
                              : 'none',
                          }}>
                          <img
                            src="/player-icons/overcast.svg"
                            className={styles.singleIcon}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                      )}
                      {podcastData?.ivoox && (
                        <a
                          className={`${styles.singleIconWrap} no-effect`}
                          href={podcastData?.ivoox || '#'}
                          rel="noreferrer"
                          target="_blank"
                          style={{
                            'pointer-events': podcastData?.ivoox
                              ? 'auto'
                              : 'none',
                          }}>
                          <img
                            src="/player-icons/ivoox.svg"
                            className={styles.singleIcon}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                      )}
                      {podcastData?.youtube && (
                        <a
                          className={`${styles.singleIconWrap} no-effect`}
                          href={podcastData?.youtube || '#'}
                          rel="noreferrer"
                          target="_blank"
                          style={{
                            'pointer-events': podcastData?.youtube
                              ? 'auto'
                              : 'none',
                          }}>
                          <img
                            src="/player-icons/youtube.svg"
                            className={styles.singleIcon}
                            alt=""
                            loading="lazy"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                )}
                {otherEpisode ? (
                  <>
                    <div className={styles.podcastSection}>
                      {otherEpisode?.other_episodes?.length > 0 && (
                        <h2 className={styles.title}>
                          {t(siteLang, 'podcast')('otherEpisodes')}
                        </h2>
                      )}
                      <MyEpisode
                        lang={siteLang}
                        // loadingStatus={false}
                        data={otherEpisode?.other_episodes}
                        hideCreate
                        isCreatorPage
                      />
                    </div>
                    <div className={styles.podcastSection}>
                      {otherEpisode?.same_category_audios?.length > 0 && (
                        <h2 className={styles.title}>
                          {t(siteLang, 'podcast')(
                            'otherCategoryEpisodesYouMayAlsoLike',
                            {
                              category:
                                siteLang === 'en'
                                  ? podcastData?.audio_category?.name
                                  : podcastData?.audio_category?.name_es,
                            },
                          )}
                        </h2>
                      )}
                      <MyEpisode
                        lang={siteLang}
                        // loadingStatus={false}
                        data={otherEpisode?.same_category_audios}
                        hideCreate
                        isCreatorPage
                      />
                    </div>
                    <div className={styles.podcastSection}>
                      {otherEpisode?.diff_category_audios?.length > 0 && (
                        <h2 className={styles.title}>
                          {t(
                            siteLang,
                            'podcast',
                          )('lastUpdatedEpisodesOnMumbler')}
                        </h2>
                      )}
                      <MyEpisode
                        lang={siteLang}
                        // loadingStatus={false}
                        data={otherEpisode?.diff_category_audios}
                        hideCreate
                        isCreatorPage
                      />
                    </div>
                  </>
                ) : (
                  <Spinner animation="grow" />
                )}

                {latestBlogPost?.length > 0 && (
                  <div className={css.blogPostSection}>
                    <h2>{t(siteLang, 'podcast')('latestBlogPosts')}</h2>
                    <Row className={css.blogListSection}>
                      {latestBlogPost?.map((item) => (
                        <Col md={6} className={css.blogBox}>
                          <div className={css.blogItem}>
                            <div className={css.thumb}>
                              <a href={item?.link}>
                                <img
                                  src={item?.featured_media?.thumbnail}
                                  alt=""
                                />
                              </a>
                            </div>
                            <div className={css.blogContent}>
                              <h4>
                                <a href={item?.link}>{item?.title?.rendered}</a>
                              </h4>
                              <p>
                                {item?.short_description?.substring(0, 78)}
                                {item?.short_description?.length > 78 && '...'}
                                <a href={item?.link} className={css.readMore}>
                                  {t(siteLang, 'podcast')('readMore')}
                                </a>
                              </p>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              </Container>

              <PublicFooter langChanger={false} lang={lang} />

              <ConfirmationPopup
                showConfirmation={showConfirmationBox}
                handleClose={() => {
                  if (
                    process.env.NEXT_PUBLIC_FRONTEND_URL ===
                    'http://localhost:3000'
                  ) {
                    Cookies.remove('subscriptionConfirmation', { path: '/' });
                  } else {
                    Cookies.remove('subscriptionConfirmation', {
                      path: '/',
                      domain: '.mumbler.io',
                    });
                  }
                  setShowConfirmationBox(false);
                }}
                title={message?.title}
                message={message?.message}
                noNeedOfAlertIcon={
                  message?.type === 'subscribe' || message?.type === 'purchase'
                }
                confirmActionCallback={
                  message?.type === 'subscribe' || message?.type === 'purchase'
                    ? message?.cardExpiresMessage
                      ? updateCreditCard
                      : () => {
                          subscribeToPodcast(podcastData, planTypeRef.current);
                        }
                    : unSubscribe
                }
                cancelButton={
                  message?.type === 'unsubscribe' &&
                  t(lang, 'podcast')('keepSubscription')
                }
                submitButton={
                  ((message?.type === 'subscribe' ||
                    message?.type === 'purchase') &&
                    message?.cardExpiresMessage &&
                    t(lang, 'podcast')('updateCreditCardButton')) ||
                  (message?.type === 'subscribe' &&
                    !message?.cardExpiresMessage &&
                    t(lang, 'podcast')('subscribeButton')) ||
                  (message?.type === 'unsubscribe' &&
                    t(lang, 'podcast')('unsubscribeButton')) ||
                  (message?.type === 'purchase' &&
                    !message?.cardExpiresMessage &&
                    t(lang, 'podcast')('purchaseButton'))
                }
                submitButtonColor={
                  message?.type === 'subscribe' || message?.type === 'purchase'
                    ? '#0d122a'
                    : null
                }
              />
              <MessagePopup
                title=""
                message={t(lang, 'podcast')('noSubscriptionsNow')}
                isOpen={showSubscriptionMessage}
                hideModal={() => {
                  setShowSubscriptionMessage(false);
                }}
              />
              <SharePopup
                show={modalShow}
                host={host}
                modalTitle={
                  isPodcast
                    ? t(lang, 'common')('sharePodcast')
                    : t(lang, 'common')('shareAudio')
                }
                shareText={t(lang, 'common')('shareText', {
                  title: podcastData?.title,
                })}
                shareUrl={podcastData?.domain_redirect_url}
                onHide={() => setModalShow(false)}
              />
              <Modal
                dialogClassName="modal-dialog-wide"
                show={showPlanSelectModal}
                onHide={() => {
                  setShowPlanSelectModal(false);
                }}>
                <Modal.Body>
                  <h4
                    style={{
                      textAlign: 'center',
                    }}>
                    {t(siteLang, 'podcast')('chooseYourPlan')}
                  </h4>
                  <div className="d-flex flex-column px-4">
                    <Button
                      varian="primary"
                      className="compact mb-4"
                      onClick={() => {
                        setShowPlanSelectModal(false);
                        planTypeRef.current = 'monthly';
                        if (
                          process.env.NEXT_PUBLIC_APP_FRONTEND_URL ===
                          'http://localhost:3000'
                        ) {
                          Cookies.set('plan_interval', planTypeRef?.current, {
                            path: '/',
                          });
                        } else {
                          Cookies.set('plan_interval', planTypeRef?.current, {
                            path: '/',
                            domain: '.mumbler.io',
                          });
                        }
                        subscribeConfirmation();
                      }}
                      style={{
                        background: podcastData?.button_color,
                        color: podcastData?.text_color,
                        borderColor: podcastData?.button_color,
                      }}>
                      {t(lang, 'podcast')('planPopupSubscribeMonthlyMessage', {
                        podcastData,
                        currency,
                      })}
                    </Button>
                    <Button
                      variant="primary"
                      className="compact mb-4"
                      onClick={() => {
                        setShowPlanSelectModal(false);
                        planTypeRef.current = 'yearly';
                        if (
                          process.env.NEXT_PUBLIC_APP_FRONTEND_URL ===
                          'http://localhost:3000'
                        ) {
                          Cookies.set('plan_interval', planTypeRef?.current, {
                            path: '/',
                          });
                        } else {
                          Cookies.set('plan_interval', planTypeRef?.current, {
                            path: '/',
                            domain: '.mumbler.io',
                          });
                        }
                        subscribeConfirmation();
                      }}
                      style={{
                        background: podcastData?.button_color,
                        color: podcastData?.text_color,
                        borderColor: podcastData?.button_color,
                        overflow: 'inherit',
                      }}>
                      {t(lang, 'podcast')('planPopupSubscribeYearlyMessage', {
                        podcastData,
                        currency,
                      })}
                    </Button>
                    <div
                      style={{
                        textAlign: 'center',
                        fontSize: '1.0rem',
                        color: 'black',
                        fontWeight: 'normal',
                        marginTop: '-0.8rem',
                      }}>
                      {t(lang, 'podcast')('planPopupSubscribeYearlySavings', {
                        podcastData,
                      })}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
};

EpisodePage = withElementsProvider(EpisodePage);

EpisodePage.getInitialProps = async (context) => {
  const { query, res } = context;
  const { token, podcaster } = cookies(context);

  const episodeId = query['episode-name'];
  let subscriptionConfirmation = false;
  const isAuthRequired = !!token;
  // const podcastSlug = query['podcast-name'];

  const subdomain =
    context?.req?.headers?.host
      ?.split('.')
      .slice(0, context?.req?.headers?.host.includes('localhost') ? -1 : -2) ||
    getSubdomain();

  const host = context?.req?.headers?.host;

  const queryParam = queryString.stringify({ subdomain });
  const response = await openEpisodeDetail(
    episodeId,
    isAuthRequired,
    token,
    queryParam,
  );

  const payload = {};
  const otherEpisodesResponse = await otherEpisodes(episodeId, queryParam);
  if (otherEpisodesResponse?.status === 200) {
    payload.otherEpisode = otherEpisodesResponse?.data?.data;
  }

  // const siteLang =
  //   response?.data?.podcast_details?.creator_language ||
  //   response?.data?.audio_series_details?.creator_language;
  const params = queryString.stringify({ per_page: 6 });
  const url = `https://mumbler.io/wp-json/wp/v2/posts/?${params}`;
  const latestBlogPostResponse = await axios.get(url);
  if (latestBlogPostResponse?.status === 200) {
    payload.latestBlogPost = latestBlogPostResponse?.data;
  }

  if (response?.status === 404) {
    if (res) {
      res.writeHead(301, {
        Location: '/404',
      });
      res.end();
    } else {
      Router.push('/404');
    }
    return {};
  }
  if (
    latestBlogPostResponse?.status === 200 &&
    otherEpisodesResponse?.status === 200 &&
    response?.status === 200
  ) {
    if (response?.data?.podcast_details?.user_subscribed) {
      if (process.env.NEXT_PUBLIC_FRONTEND_URL === 'http://localhost:3000') {
        Cookies.remove('subscriptionConfirmation', { path: '/' });
      } else {
        Cookies.remove('subscriptionConfirmation', {
          path: '/',
          domain: '.mumbler.io',
        });
      }
    } else if (response?.data?.audio_series_details?.user_subscribed) {
      if (process.env.NEXT_PUBLIC_FRONTEND_URL === 'http://localhost:3000') {
        Cookies.remove('subscriptionConfirmation', { path: '/' });
      } else {
        Cookies.remove('subscriptionConfirmation', {
          path: '/',
          domain: '.mumbler.io',
        });
      }
    } else {
      subscriptionConfirmation = cookies(context).subscriptionConfirmation;
    }

    return {
      ...payload,
      episodeData: response?.data,
      podcastData:
        response?.data?.podcast_details || response?.data?.audio_series_details,
      slug:
        response?.data?.audio_type === 'podcast'
          ? response?.data?.podcast_details?.slug
          : response?.data?.audio_series_details?.slug,
      host,
      subscriptionConfirmation,
      token,
      podcaster: parseInt(podcaster, 10),
      isPodcast:
        response?.data?.podcast_details?.audio_type === 'podcast' ||
        response?.data?.audio_series_details?.audio_type === 'podcast',
    };
  }
  return {};
};

EpisodePage.propTypes = {
  episodeData: PropTypes.object,
  podcastData: PropTypes.object,
  slug: PropTypes.string,
  subscriptionConfirmation: PropTypes.string,
  token: PropTypes.string,
  isPodcast: PropTypes.bool,
  latestBlogPost: PropTypes.array,
  otherEpisode: PropTypes.array,
  host: PropTypes.string,
  podcaster: PropTypes.number,
};

export default EpisodePage;
